import { gsap }               from "gsap/dist/gsap";
import { ScrambleTextPlugin } from "gsap/dist/ScrambleTextPlugin";
import { SplitText }          from "gsap/dist/SplitText";
gsap.registerPlugin(ScrambleTextPlugin, SplitText);

import {x, x0} from '../_helpers';

export default class SplitLines {

    constructor() {
        this.split = null;
        this.init();
    }

    init() {
        const _elements = x('[js-split]');
        this.split = new SplitText(_elements, {type:"words,lines"});
        window.addEventListener('resize', e => {
            this.split.revert();
            this.split = new SplitText(_elements, {type:"words,lines"});
        })
    }
}